import {useState, useEffect} from "react";
import ProxyTable from '../../components/_common/Table/proxyTable';
import type { ColumnsType } from 'antd/es/table';

import {Input} from "antd";
const {Search} = Input;

export interface InputProps {
  data: any,
  columns: ColumnsType<any>,
permission:any}


const SearchBar = ({data,columns,permission}:InputProps) => {
    const [filteredData, setFilteredData] = useState([]);
    const [input, setInput] = useState("");

    useEffect(() => {
      setFilteredData(data);
      setInput("");
    }, [data]);

  const handleFilter = (e:any) => {
  console.log(e);
  const searchInput = e.target.value;
  setInput(searchInput);

  const newFilter = data.filter((value:any) => {
    return (value.str_LabPersianName ?value.str_LabPersianName.toLowerCase().includes(searchInput.toLowerCase()): "") ||
          (value.prk_AndriodLab_AutoID? value.prk_AndriodLab_AutoID.toString().includes(searchInput.toLowerCase()):"") ||
          (value.str_StateName? value.str_StateName.toLowerCase().includes(searchInput.toLowerCase()):"");
  });

//   const newFilter = data.filter((value:any) => {
//   //return value.str_LabPersianName.toLowerCase().includes(searchInput.toLowerCase());
//   return Object.values(value).join('').toLowerCase().includes(searchInput.toLowerCase())
// });
  if (searchInput === "") {
    setFilteredData(data);
  } 
  else 
  {
    setFilteredData(newFilter);
  }
};

return(
      <div className="proxy-search">
          <div className="searchInputs">
          <Search
            placeholder="جستجو بر اساس نام/استان/کد مرکز" 
            value={input}
            onChange={(e) => handleFilter(e)}       
            enterButton
          />
        </div>
        {
        filteredData.length != 0 && (
        <div className="dataResult">
          <ProxyTable columns={columns} data={filteredData} isloading={false} permission={permission} />
        </div>
    )}
      </div>  
 )
      
}
export default SearchBar